import type { Regimen } from "@/data/meal-plan/types.ts";
import {
  VEGETABLES_FRESH,
  VEGETABLES_SMALL,
  EGG_YOLK_NOTE,
} from "@/data/meal-plan/options.ts";
import {
  ROMINA_BREAKFAST_CARBS,
  ROMINA_LUNCH_CARBS,
  ROMINA_MID_AFTERNOON_CARBS,
  ROMINA_DINNER_CARBS,
  ROMINA_SMALL_PROTEINS,
  ROMINA_DINNER_PROTEINS,
  ROMINA_LUNCH_PROTEINS,
  ROMINA_FRUITS,
  ROMINA_FATS,
  ROMINA_MID_AFTERNOON_FATS,
} from "./options.ts";

export const rominaRestRegimen: Regimen = {
  id: "romina-rest",
  name: "Días sin Entrenamiento",
  badge: "R",
  description: "Régimen para días de descanso sin actividad física programada",
  meals: [
    {
      name: "breakfast",
      label: "Desayuno",
      choices: [
        {
          category: "carb",
          pick: 1,
          canRepeat: false,
          options: ROMINA_BREAKFAST_CARBS,
        },
        {
          category: "fruit",
          pick: 1,
          canRepeat: false,
          options: ROMINA_FRUITS,
        },
        {
          category: "protein",
          pick: 4,
          canRepeat: true,
          note: EGG_YOLK_NOTE,
          options: ROMINA_SMALL_PROTEINS,
        },
        {
          category: "fat",
          pick: 1,
          canRepeat: false,
          options: ROMINA_FATS,
        },
      ],
    },
    {
      name: "lunch",
      label: "Almuerzo",
      choices: [
        {
          category: "carb",
          pick: 2,
          canRepeat: true,
          options: ROMINA_LUNCH_CARBS,
        },
        {
          category: "protein",
          pick: 1,
          canRepeat: false,
          options: ROMINA_LUNCH_PROTEINS,
        },
        {
          category: "vegetable",
          pick: 1,
          canRepeat: false,
          options: VEGETABLES_FRESH,
        },
        {
          category: "fat",
          pick: 2,
          canRepeat: true,
          options: ROMINA_FATS,
        },
      ],
    },
    {
      name: "mid-afternoon",
      label: "Media Tarde",
      choices: [
        {
          category: "carb",
          pick: 1,
          canRepeat: false,
          options: ROMINA_MID_AFTERNOON_CARBS,
        },
        {
          category: "fat",
          pick: 1,
          canRepeat: false,
          options: ROMINA_MID_AFTERNOON_FATS,
        },
      ],
    },
    {
      name: "dinner",
      label: "Cena",
      choices: [
        {
          category: "carb",
          pick: 1,
          canRepeat: false,
          options: ROMINA_DINNER_CARBS,
        },
        {
          category: "protein",
          pick: 4,
          canRepeat: true,
          note: EGG_YOLK_NOTE,
          options: ROMINA_DINNER_PROTEINS,
        },
        {
          category: "vegetable",
          pick: 1,
          canRepeat: false,
          optional: true,
          options: VEGETABLES_SMALL,
        },
        {
          category: "fat",
          pick: 1,
          canRepeat: false,
          options: ROMINA_FATS,
        },
      ],
    },
    {
      name: "training-extra",
      label: "Adicional por Entrenamiento",
      choices: [
        {
          category: "fruit",
          pick: 1,
          canRepeat: false,
          options: ROMINA_FRUITS,
        },
      ],
    },
  ],
};
